<template>
  <LegalPage
    title="Privacy Policy"
    subtitle="Last updated: August 2026"
    intro="This page explains how gbmodshub.net handles information when you browse the site or send an email."
    :sections="sections"
    email="contact@gbmodshub.net"
    page-name="privacy"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Privacy',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'What This Policy Covers',
          paragraphs: [
            'This policy applies to gbmodshub.net, an independent guide about GB WhatsApp APK downloads and installation. We do not develop, host, or distribute the application.',
            'Any mention of GB WhatsApp, WhatsApp, or related products is for identification and explanation only. It does not create a partnership with WhatsApp Inc., Meta, or any third-party developer.',
          ],
        },
        {
          heading: 'Information We Process',
          paragraphs: [
            'Standard server and analytics data may be processed when pages are opened. This can include browser and device information, pages viewed, referring URLs, and the time of the visit.',
            'If you contact the address listed on this site, we receive your email address and the content of your message. We use that information only to answer the request.',
          ],
        },
        {
          heading: 'Why We Use This Information',
          paragraphs: [
            'The information is used to keep the site stable, review how pages are used, improve outdated guidance, and answer reader questions.',
          ],
          items: [
            'Monitor site availability and basic security.',
            'Identify pages that need clearer instructions.',
            'Respond to messages about APK information or installation.',
            'Prevent spam or misuse of the public contact email.',
          ],
        },
        {
          heading: 'Cookies and Similar Tools',
          paragraphs: [
            'Basic cookies or similar technologies may be used for visitor measurement and preferences. Disabling them in your browser should not prevent you from reading the written content.',
          ],
        },
        {
          heading: 'Third-Party Resources',
          paragraphs: [
            'The site may link to external download pages, APK files, or other websites. We do not control their privacy practices, security, or file availability.',
            'Review each external source before installing any file and check whether the APK is suitable for your device and Android version.',
          ],
        },
        {
          heading: 'Security and Retention',
          paragraphs: [
            'We use reasonable measures to protect the site and email contact, but no online service can provide complete security.',
          ],
        },
        {
          heading: 'Children',
          paragraphs: [
            'This website is intended for users who are old enough to use Android messaging applications. We do not knowingly collect personal information from children.',
          ],
        },
        {
          heading: 'Updates to This Policy',
          paragraphs: [
            'This policy may change when site practices change. The latest version will be posted on this page.',
          ],
        },
      ],
    };
  },
};
</script>
